export interface RefField {
  id?: string | null;
  code?: number | null;
  key?: string | null;
  name?: string | null;
}

export function createRefField(data?: Partial<RefField>): RefField {
  return {
    id: data?.id,
    code: data?.code,
    key: data?.key,
    name: data?.name,
  };
}
